// removed by extract-text-webpack-plugin
module.exports = {"warning":"warning_2ZUwX","messageWrapper":"messageWrapper_3y3pK","marker":"marker_194fY","message":"message_10Ar-"};


//////////////////
// WEBPACK FOOTER
// ./app/components/moment-warning/styles.scss
// module id = 475
// module chunks = 1